import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { VaccinationDocumentService } from '../../services/vaccination-document.service';
import { finalize } from 'rxjs/operators';
import { AppService } from '../../services/app.service';
import { IVaccinationDocument } from '../../models/VaccinationDocument';
import { Utils } from '../../core/Utils';

export type VaccinationDocumentApprovalAction = 'Approve' | 'Reject';

@Component({
    selector: 'app-vaccination-document-approval',
    templateUrl: './approval.component.html'
})
export class VaccinationDocumentApprovalComponent {
    constructor(
        private app: AppService,
        private service: VaccinationDocumentService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() document: IVaccinationDocument;

    action: VaccinationDocumentApprovalAction;
    comment: string;

    readonly actions: VaccinationDocumentApprovalAction[] = ['Approve', 'Reject'];
    readonly commentMaxLength = 1000;
    readonly getMaxLengthValidationPattern = Utils.getMaxLengthValidationPattern;

    isSaving: boolean;

    get isCommentRequired() {
        return this.action == 'Reject';
    }

    submit() {
        const success = () => {
            this.app.notify(this.app.translate('vaccinationDocument_reviewed'));
            this.activeModal.close();
        };

        this.isSaving = true;

        const req = this.action == 'Approve'
            ? this.service.approve(this.document.Id, this.comment)
            : this.service.reject(this.document.Id, this.comment);

        this.app.addLoading(req, 500).pipe(finalize(() => this.isSaving = false)).subscribe(success);
    }

    cancel() {
        this.activeModal.dismiss();
    }

    download() {
        this.app.addLoading(this.service.download(this.document.Id)).subscribe();
    }
}
